export const ADD_SUSPICIOUS_TOAST = 'ADD_SUSPICIOUS_TOAST';
export const REMOVE_SUSPICIOUS_TOAST = 'REMOVE_SUSPICIOUS_TOAST';
